import React, { useEffect, useRef, useState } from 'react';
import './BusinessCount.css';
import { Box, Grid, Typography } from '@mui/material';
import { formatCount } from '../../../helper/global';

const CountingBox = ({ target, desc, onComplete }) => {
  const [count, setCount] = useState(0);
  const countingRef = useRef(null);

  useEffect(() => {
    if (target > 0) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      };

      const handleIntersect = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const validTarget = isNaN(target) ? 0 : parseInt(target, 10);
            let currentCount = 0;
            const increment = Math.ceil(target / 100);
            const interval = setInterval(() => {
              currentCount += increment;
              setCount((prevCount) => Math.min(prevCount + increment, validTarget));
              if (currentCount >= target) {
                clearInterval(interval);
                observer.unobserve(entry.target);
                onComplete();
              }
            }, 10);
          }
        });
      };

      const observer = new IntersectionObserver(handleIntersect, options);
      if (countingRef.current) {
        observer.observe(countingRef.current);
      }
      return () => observer.disconnect();
    }
  }, [target, onComplete]);

  return (
    <Grid item xs={5} sm={4} md={3} lg={3} xl={3} ref={countingRef}>
      <Box className="counting_box">
        <Typography component="span" className="counting_text">
          {formatCount(count, desc)}
        </Typography>
        <Typography component="span" className="counting_desc">
          {desc}
        </Typography>
      </Box>
    </Grid>
  );
};

const BusinessCount = ({ businessCount }) => {
  const [loading, setLoading] = useState(true);
  const [completedCounts, setCompletedCounts] = useState(0);
  const totalCounters = 4;

  const handleCountComplete = () => {
    setCompletedCounts((prev) => prev + 1);
  };

  useEffect(() => {
    if (completedCounts === totalCounters) {
      setLoading(false);
    }
  }, [completedCounts]);

  return (
    <Box className="cmn-pl-pr">
      <Box className="counting_main">
        <Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'center' }}>
          <CountingBox
            target={businessCount?.years_of_legacy || 0}
            desc="Years Of Legacy"
            isLoading={loading}
            onComplete={handleCountComplete}
          />
          <CountingBox
            target={businessCount?.skilled_team || 0}
            desc="Skilled Team"
            isLoading={loading}
            onComplete={handleCountComplete}
          />
          <CountingBox
            target={businessCount?.satisfied_guests || 0}
            desc="Satisfied Guests"
            isLoading={loading}
            onComplete={handleCountComplete}
          />
          <CountingBox
            target={businessCount?.tour_options || 0}
            desc="Tour Options"
            isLoading={loading}
            onComplete={handleCountComplete}
          />
        </Grid>
      </Box>
    </Box>
  );
};
export default BusinessCount;
